import { pathByRouteName } from './routes';

// Pages where nudging the user to verify their email would be redundant (they're
// already on the verification/auth/contact-details flow) or actively unwanted
// (mid-checkout/order, where the prompt must never interrupt booking).
export const EMAIL_VERIFICATION_PROMPT_WHITELIST_ROUTES = [
  'LoginPage',
  'SignupPage',
  'ContactDetailsPage',
  'EmailVerificationPage',
  'PasswordResetPage',
  'StripePayoutPage',
];

export const isEmailVerificationPromptExcluded = (pathname, routeConfiguration) => {
  if (!pathname) {
    return false;
  }

  const whitelistedPaths = EMAIL_VERIFICATION_PROMPT_WHITELIST_ROUTES.map(page =>
    pathByRouteName(page, routeConfiguration)
  );

  return (
    whitelistedPaths.includes(pathname) ||
    pathname.includes('checkout') ||
    pathname.includes('order')
  );
};
